import ApiNode from './ApiNode'

export default {
    getPendingNotes(params) {
        return ApiNode().post('credit-debit-notes/pending', params);
    },
    approveNote(params) {
        return ApiNode().post('credit-debit-notes/approve', params);
    },
    rejectNote(params) {
        return ApiNode().post('credit-debit-notes/reject', params);
    },
    sendForApproval(params) {
        return ApiNode().post('credit-debit-notes/send-approval', params);
    }
}



// WEBPACK FOOTER //
// ./src/services/CreditDebitNoteService.js